module.exports = __webpack_public_path__ + "img/timestampBanner.0534d0c3.png";